import { render, staticRenderFns } from "./ProjectTaskNewFrProject.vue?vue&type=template&id=551a42bd&"
import script from "./ProjectTaskNewFrProject.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskNewFrProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports